import { SET_TIMEOUT_VALUE } from "../../../../constants/app-constants";
import { withApollo } from "react-apollo";
import React from "react";
import {
  getListOfAutoNumeringQuery,
  deleteAutoNumberingQuery
} from "../../../../services/graphql/queries/auto-numbering";
import AutoNumberingAdd from "./AutoNumberingAdd";
import AutoNumberingModify from "./AutoNumberingModify";
import { setISODay } from "date-fns";
import ReactModal from "../../../Common/ReactModal";

class AutoNumbering extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedRecord: null,
      autoNumbering: [],
      isListMode: true,
      isSuccess: false,
      loading: false,
      errors: [],
      error: "",
      reactModalVisible: false,
      requireCancel: true,
      modalMessage: "Are you sure you want to delete",
      deleteId: ""
    };

    this.modify = this.modify.bind(this);
    this.delete = this.delete.bind(this);
    this.switchToAddMode = this.switchToAddMode.bind(this);
    this.listMode = this.listMode.bind(this);
    this.switchToListMode = this.switchToListMode.bind(this);
    // this.onOkClicked = this.onOkClicked.bind(this);
  }

  modify(e, id) {
    e.preventDefault();
    const selectedRecords = this.state.autoNumbering.filter(element => {
      return element.Id === id ? true : false;
    });

    this.setState({
      selectedRecord: selectedRecords[0],
      isListMode: false
    });
  }

  delete(e, id) {
    e.preventDefault();
    console.log("Delete: ", id);

    //Use this ID and make a graphql call to delete
    this.setState({ reactModalVisible: true, deleteId: id });
  }

  onOkClicked() {
    this.setState({ reactModalVisible: false });
    this.props.client
      .mutate({
        mutation: deleteAutoNumberingQuery,
        variables: {
          id: this.state.deleteId
        },
        fetchPolicy: "no-cache"
      })
      .then(result => {
        this.switchToListMode();
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, errors: error.message });
      });
  }

  onCancelClicked() {
    this.setState({ reactModalVisible: false });
  }

  switchToAddMode() {
    this.setState({ selectedRecord: null });
  }

  listMode(mode) {
    this.setState({ isListMode: mode, selectedRecord: null });
  }

  switchToListMode() {
    this.setState({ loading: true, isSuccess: true });
    console.log(this.props.userId);
    this.props.client
      .query({
        query: getListOfAutoNumeringQuery,
        variables: { transactionType: this.props.user.Id },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const user = result.data.getListofAutoNumbering;
        this.initialState = {
          autoNumbering: user
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.getListofAutoNumbering);
      })
      .catch(error => {
        // console.log("~~~error: ", error);
        // this.setState({ loading: false, error: error.message });
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  componentDidMount() {
    this.setState({ loading: true });
    if (this.props.user.Id) {
      this.props.client
        .query({
          query: getListOfAutoNumeringQuery,
          variables: { transactionType: this.props.user.Id },
          fetchPolicy: "network-only"
        })
        .then(result => {
          const user = result.data.getListofAutoNumbering;
          this.initialState = {
            autoNumbering: user
          };

          this.setState({ ...this.initialState });
          this.setState({ loading: false, error: "" });
          console.log("~~~result: ", result.data.getListofAutoNumbering);
        })
        .catch(error => {
          // console.log("~~~error: ", error);
          // this.setState({ loading: false, error: error.message });
          error.graphQLErrors.map(({ message }, i) => {
            this.setState(prevState => {
              return { errors: [message] };
            });
          });
          setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    }
  }

  render() {
    const { userId, allowEditing } = this.props;
    const {
      selectedRecord,
      autoNumbering,
      isSuccess,
      reactModalVisible,
      requireCancel,
      modalMessage,
      errors,
      loading,
      error
    } = this.state;
    return (
      <div
        className="tab-pane fade show active"
        id="specs"
        role="tabpanel"
        aria-labelledby="specs-tab"
      >
        <div className="box-card">
          <div className="row">
            <div className="col-md-12">
              {this.state.isListMode ? (
                <div>
                  {/* List View Start */}
                  <div className="row align-items-center">
                    <div className="col-md-10">
                      <h1 className="heading">Auto Numbering List View </h1>
                    </div>
                    <div className="col-md-2 text-right">
                      {allowEditing ? (
                        <a
                          href="#"
                          className="link-click m-l-45"
                          onClick={() => this.listMode(false)}
                        >
                          <img src="/static/images/svg/Add.svg" /> Add
                        </a>
                      ) : null}
                    </div>
                  </div>

                  <div
                    className="alert alert-success p-0 m-t-10 m-b-0"
                    role="alert"
                  >
                    {isSuccess ? (
                      <span>
                        <img src="/static/images/svg/Success.svg" /> Success
                      </span>
                    ) : null}
                  </div>
                  {/* Table Section Start */}
                  <div className="table-responsive">
                    <>
                      <table className="table table-style-1 m-t-35">
                        <thead>
                          <tr>
                            <th>START DATE</th>
                            <th>END DATE</th>
                            <th>NEXT NUMBER</th>
                            <th>RETURN AS</th>
                            {allowEditing ? <th>ACTION(s)</th> : null}
                          </tr>
                        </thead>
                        <tbody>
                          {autoNumbering.length ? (
                            autoNumbering.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td>{data.startDate}</td>
                                  <td>{data.endDate}</td>
                                  <td>{data.nextNumber}</td>
                                  <td>
                                    {data.returnsAs === "N"
                                      ? "NUMBER"
                                      : "STRING"}
                                  </td>
                                  <td>
                                    {allowEditing ? (
                                      <a
                                        href="#"
                                        className="link-primary m-l-45"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Modify"
                                        onClick={e => {
                                          this.modify(e, data.Id);
                                        }}
                                      >
                                        <img src="/static/images/svg/Modify.svg" />
                                      </a>
                                    ) : null}
                                    {allowEditing ? (
                                      <a
                                        href="#"
                                        className="link-delete m-l-45"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Delete"
                                        onClick={e => {
                                          this.delete(e, data.Id);
                                        }}
                                      >
                                        <img src="/static/images/svg/Delete.svg" />
                                      </a>
                                    ) : null}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <div
                              style={{ textAlign: "right", fontSize: "14px" }}
                            >
                              No Data
                            </div>
                          )}
                        </tbody>
                      </table>
                    </>
                  </div>
                  {/* Table Section End */}
                  {/* List View End */}
                </div>
              ) : (
                <div>
                  {/* Add New Role View Start */}
                  {selectedRecord ? (
                    <AutoNumberingModify
                      user={this.props.user}
                      userId={userId}
                      selectedRecord={selectedRecord}
                      switchToAddMode={this.switchToAddMode}
                      switchToListMode={this.switchToListMode}
                      listMode={this.listMode}
                    />
                  ) : (
                    <AutoNumberingAdd
                      user={this.props.user}
                      userId={userId}
                      switchToListMode={this.switchToListMode}
                      listMode={this.listMode}
                    />
                  )}
                  {/* Add New Role End */}
                </div>
              )}
            </div>
          </div>
        </div>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.onOkClicked.bind(this)}
          closeModal={this.onCancelClicked.bind(this)}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
      </div>
    );
  }
}

export default withApollo(AutoNumbering);
